import { useSelector } from 'react-redux'
import { isLoaded, useFirestoreConnect } from 'react-redux-firebase'
import naturalSort from 'javascript-natural-sort'
import type { Apartment } from 'types/apartment'

export const useCompanyApartments = (selectedCompanyUUID: string) => {
	useFirestoreConnect([
		{
			collection: 'apartment',
			storeAs: `companyApartments_${selectedCompanyUUID}`,
			where: [['companyUUID', '==', selectedCompanyUUID]],
		},
	])

	return useSelector(({ firestoreReducer }: any) => {
		const apartmentList = firestoreReducer.ordered[
			`companyApartments_${selectedCompanyUUID}`
		] as Apartment[]

		if (!isLoaded(apartmentList)) {
			return { loadingCompanyApartments: true, companyApartments: [] }
		}

		const sortedApartments =
			Array.isArray(apartmentList) && apartmentList.length > 0
				? [...apartmentList].sort((a, b) =>
						naturalSort(a.identifier, b.identifier),
				  )
				: []

		return {
			loadingCompanyApartments: false,
			companyApartments: sortedApartments,
		}
	})
}
